import operators from './predicateOperators';

interface Condition {
  operator: string;
  values?: Array<string | number | boolean>;
  value?: string | number | boolean;
  predicate: string;
}

interface Rule {
  conditions: Condition[];
  variation: any;
}

type Predicates = Record<string, any>;

interface Configuration {
  enabled?: boolean;
  disabledVariation?: any;
  rules: Rule[];
  defaultVariation: any;
}

const checkCondition = ({ predicateValue, operator, values }) =>
  operators[operator](predicateValue, values);

const matchRule = (rules: Rule[] = [], predicates: Predicates) =>
  rules?.find((rule) =>
    rule?.conditions?.every((condition) =>
      checkCondition({
        ...condition,
        ...(!condition?.values && { values: [condition?.value] }),
        predicateValue: predicates[condition?.predicate],
      })
    )
  );

export const getVariation = (
  configuration: Configuration,
  predicates: Predicates = {}
) => {
  try {
    if (
      Object.prototype.hasOwnProperty.call(configuration, 'enabled') &&
      !configuration.enabled
    ) {
      return configuration?.disabledVariation;
    }

    const rule = matchRule(configuration?.rules, predicates);

    if (!rule) {
      return configuration?.defaultVariation;
    }

    return rule?.variation;
  } catch (error) {
    console.error('Error in getVariation:', error);
    return configuration?.defaultVariation;
  }
};
